import { Injectable } from '@angular/core';
import { LocalService } from './storage/local.service';

export class UtmRequest
{
    utm_campaign: string;
    utm_source: string;
    utm_medium: string;
    utm_content: string;
    utm_term: string;
    adpos: string;
    device: string;
    keyword: string;
    matchtype: string;
    submitted_from_ip: string;

    constructor(request: any) {
        if (request) {
            this.utm_campaign = request.utm_campaign || '';
            this.utm_source = request.utm_source || '';
            this.utm_medium = request.utm_medium || '';
            this.utm_content = request.utm_content || '';
            this.utm_term = (request.utm_term) ? request.utm_term.join(',') : '';
            this.adpos = request.adpos || '';
            this.device = request.device || '';
            this.keyword = request.keyword || '';
            this.matchtype = request.matchtype || '';
            this.submitted_from_ip = request.submitted_from_ip || '';
        } else {
            this.utm_campaign = '';
            this.utm_source = '';
            this.utm_medium = '';
            this.utm_content = '';
            this.utm_term = '';
            this.adpos = '';
            this.device = '';
            this.keyword = '';
            this.matchtype = '';
            this.submitted_from_ip = '';
        }
    }
}

@Injectable({
    providedIn: 'root',
})
export class UtmService
{
    public static StorageKey = 'payhoa-utm';

    public static read(): UtmRequest {
        const data = LocalService.get(UtmService.StorageKey);

        return new UtmRequest(JSON.parse(data));
    }

    public static clear(): void {
        LocalService.destroy(UtmService.StorageKey);
    }

    public static store(data: string): void {
        LocalService.set(UtmService.StorageKey, data);
    }

}
